<p-panel header="{{'fs.res.publication.Publication.abstract' | hisUi}}">
    
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam [showLabelTop]="true">
		<textarea #content hisDdKey="fs.res.publication.Publication.textAbstract" 
			[rows]="20" [cols]="110" class="textareaWidth100" 
			[ngModel]="publication.textAbstract"
			[hisObject]="publication" hisAttribute="textAbstract">
		</textarea>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
</p-panel>
